<template>
  <div class="round">
    <div class="header">
      <div>
        <template v-if="device.name.length>5">
          <el-tooltip :content="device.name" placement="bottom" effect="dark">
            <span v-text="device.name"></span>
          </el-tooltip>
        </template>
        <template v-else>
          <span v-text="device.name" :title="device.name"></span>
        </template>
      </div>
      <div>
        <img :src="icon" style="width: 85px" @click="powerSwitch" v-if="isClose"/>
      </div>
    </div>
    <div class="content">
      <div class="middle">
        <div class="placeholder">
          <slot name="left"></slot>
        </div>
        <slot></slot>
        <div class="star">
          <slot name="right"></slot>
          <img :src="starIcon" style="width: 28px" id="star" title="点亮收藏至常用设备" @click="collection"/>
        </div>
      </div>
    </div>
    <div class="footer">
      <slot name="footer">
      </slot>
    </div>
  </div>
</template>

<script>
import api from '../model/device'
import { Message } from 'element-ui'

export default {
  name: 'Round',
  props: {
    device: {
      type: Object,
      default () {
        return { name: '', state: 0 }
      }
    },
    isClose: {
      type: Boolean,
      default: true
    }
  },
  computed: {
    isCollection () {
      let isHas = this.$store.state.collection.devices.filter(s => s.id === this.device.id && s.type === (this.device.devicetype ? this.device.devicetype.key : 'light')).length
      if (this.device.unique) {
        isHas = this.$store.state.collection.devices.filter(s => s.id === this.device.unique && s.type === this.device.key).length
      }
      return isHas
    },
    starIcon () {
      if (this.isCollection) {
        return require('../assets/images/scene/ysc.png')
      } else {
        return require('../assets/images/scene/sc.png')
      }
    },
    icon () {
      // if (this.device.sid == 1 && this.device.devicetype && this.device.devicetype.key === 'airswitch') { console.log(this.device) }
      if (typeof this.device.state === 'object' ? this.device.state.state : this.device.state) {
        return require('../assets/images/home/open.png')
      } else {
        return require('../assets/images/home/close.png')
      }
    }
  },
  methods: {
    async powerSwitch () {
      try {
        const state = typeof this.device.state === 'object' ? this.device.state.state : this.device.state
        if (this.device.unique) {
          await api.otherExtDeviceControl({ deviceId: this.device.unique, cmdParam: state ? 2 : 1, channel: 1 })
        } else {
          await api.singleControl(this.device, state ? 'close' : 'open')
        }
      } catch (e) {
        Message.error(e.message)
      }
    },
    collection () {
      // 进行相应的收藏或取消收藏操作
      let data = { id: this.device.id, type: this.device.devicetype ? this.device.devicetype.key : 'light', remark: this.device.name }
      if (this.device.unique) {
        data = {
          id: this.device.unique,
          type: this.device.key,
          remark: this.device.name
        }
      }
      if (this.isCollection) {
        this.$store.commit('UN_COLLECT', {
          type: 'device',
          data
        })
      } else {
        this.$store.commit('COLLECT', {
          type: 'device',
          data
        })
        // this.$store.commit('SET_TIP', '收藏成功')
      }
    }
  }
}
</script>

<style scoped lang="less">
@import "../assets/less/base";

.round {
  padding: 20px;
  background: rgba(255, 255, 255, 1);
  box-shadow: 0px 3px 17px 2px rgba(219, 219, 219, 0.3);
  border-radius: 8px;
  display: flex;
  height: 260px;
  min-width: 230px;
  max-width: 24%;
  flex-direction: column;
  > .header {
    display: flex;
    justify-content: space-between;
    align-items: center;
    height: 33px;
    > div:first-child {
      flex: 1;
      .auto-hide;
      font-size: 18px;
      font-weight: 600;
      color: rgba(38, 38, 38, 1);
      margin-right: 8px;
      width: 0;
    }
    > div:last-child {
      .text-right;
      width: 85px;
    }
    img {
      cursor: pointer;
    }
  }
  .content {
    flex: 1;
    display: flex;
    align-items: center;
    justify-content: center;
    .middle {
      display: flex;
      padding: 15px 0px;
      height: 100%;
      justify-content: space-between;
      align-items: center;
      width: 100%;
      > .placeholder {
        width: 28px;
      }
      .star {
        display: flex;
        align-items: flex-start;
        height: 100%;
      }
      img {
        cursor: pointer;
      }
    }
  }
  .footer {
    height: 66px;
  }
}
</style>
